/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELLogRecord,
  OTELLogRecord$Outbound,
  OTELLogRecord$outboundSchema,
} from "./otellogrecord.js";
import {
  OTELScope,
  OTELScope$Outbound,
  OTELScope$outboundSchema,
} from "./otelscope.js";

/**
 * OTEL scope logs container
 */
export type OTELScopeLog = {
  /**
   * Array of log records
   */
  logRecords?: Array<OTELLogRecord> | undefined;
  /**
   * OTEL instrumentation scope
   */
  scope?: OTELScope | undefined;
};

/** @internal */
export type OTELScopeLog$Outbound = {
  logRecords?: Array<OTELLogRecord$Outbound> | undefined;
  scope?: OTELScope$Outbound | undefined;
};

/** @internal */
export const OTELScopeLog$outboundSchema: z.ZodMiniType<
  OTELScopeLog$Outbound,
  OTELScopeLog
> = z.object({
  logRecords: z.optional(z.array(OTELLogRecord$outboundSchema)),
  scope: z.optional(OTELScope$outboundSchema),
});

export function otelScopeLogToJSON(otelScopeLog: OTELScopeLog): string {
  return JSON.stringify(OTELScopeLog$outboundSchema.parse(otelScopeLog));
}
